import { Component, Input, OnInit } from '@angular/core';
import { FbGeneralButtonConfiguration } from './fb-general-button.configuration';

@Component({
  selector: 'fb-general-button',
  templateUrl: './fb-general-button.component.html',
  styleUrls: ['./fb-general-button.component.scss']
})
export class FbGeneralButtonComponent implements OnInit {

  @Input() configuration! : FbGeneralButtonConfiguration;

  constructor() { }

  ngOnInit() {
  }

}
